/* ErrorScreen.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ErrorScreen.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl-next';
import { LinkButton } from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import Link from '@atlaskit/link';
import { ConfluenceLogo } from '@atlaskit/logo';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { Stack, Text, Box } from '@atlaskit/primitives/compiled';
import { ExperienceContext, ExperienceTrackerContext } from '@atlassian/experience-tracker';
import { ExperienceReasons } from '../experience-tracker/ExperienceNames';
import { LoginToConfluenceIcon } from '../assets/LoginPageIconSVG';
import messages from './messages';
import { usePerformanceMetrics } from '../performance-metrics/performanceMetricsProvider';
var LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES = 'https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-browser-cookies/';
var styles = {
  loginButtonWrapper: "_19pkxy5q _otyrpxbi",
  mainWrapper: "_1e0c1n7u _4cvr1h6o _6a6z1h6o _y3gn1h6o"
};
export var ErrorScreen = function ErrorScreen(_ref) {
  var standaloneConfluenceUrl = _ref.standaloneConfluenceUrl;
  var experienceTracker = useContext(ExperienceTrackerContext);
  var experience = useContext(ExperienceContext);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _usePerformanceMetric = usePerformanceMetrics(),
    cancelIframeLoadMetrics = _usePerformanceMetric.cancelIframeLoadMetrics;
  useEffect(function () {
    cancelIframeLoadMetrics();
  }, [cancelIframeLoadMetrics]);
  useEffect(function () {
    experienceTracker.abort({
      name: experience,
      reason: ExperienceReasons.UNABLE_TO_DISPLAY_CONTENT
    });
  }, [experience, experienceTracker]);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "error-screen-container",
    className: ax([styles.mainWrapper])
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.250",
    alignInline: "center"
  }, /*#__PURE__*/React.createElement(ConfluenceLogo, {
    size: "large",
    appearance: "brand"
  }), /*#__PURE__*/React.createElement(LoginToConfluenceIcon, null), /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    size: "large"
  }, formatMessage(messages.paragraphLogin))), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.loginButtonWrapper
    // data tag for JSM KB to target for excluding LinkButton from global styles
    // used instead of className as the className prop is not allowed
    // suggested by #help-design-system https://atlassian.slack.com/archives/CFJ9DU39U/p1746963980938489
    ,
    "data-embedded-confluence-no-global-styles-link-button": "true"
  }, /*#__PURE__*/React.createElement(LinkButton, {
    appearance: "primary",
    "aria-label": formatMessage(messages.buttonLoginToConfluenceNewTab),
    iconAfter: LinkExternalIcon,
    href: standaloneConfluenceUrl !== null && standaloneConfluenceUrl !== void 0 ? standaloneConfluenceUrl : '',
    target: "_blank"
  }, formatMessage(messages.buttonLoginToConfluenceNewTab))), /*#__PURE__*/React.createElement(Stack, {
    space: "space.150"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, formatMessage(messages.paragraphAlreadyLoggedIn)), /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, formatMessage(messages.paragraphStillHavingTrouble, {
    link: /*#__PURE__*/React.createElement(Link, {
      href: LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES,
      target: "_blank",
      "aria-label": formatMessage(messages.linkAriaLabel)
    }, formatMessage(messages.linkTroubleshootingText))
  }))));
};